import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unset } from './MissingData'

const key = IdentificationUrlKeys.LinkedId
const label = 'linkedID' // visitFilterLabelMap[key] // conforming the existing analytics label

export const linkedIdColumn = columnHelper.display({
  id: 'linkedId',
  header: 'Linked ID',
  cell: ({ row }) => {
    const linkedId = row.original.linked_id
    if (!linkedId) {
      return <Unset />
    }

    return (
      <CellAction
        copyValue={linkedId}
        search={(old) => ({ ...old, [key]: linkedId })}
        field={label}
        className='max-w-72 truncate'
      >
        <Typography className='font-mono'>{linkedId}</Typography>
      </CellAction>
    )
  },
})
